import {InitDownload} from './pages/download';
import {InitUpload} from './pages/upload';

export {InitUpload, InitDownload};

window.InitUpload = InitUpload;
window.InitDownload = InitDownload;
